import script from "./Opis.vue?vue&type=script&setup=true&lang=js"
export * from "./Opis.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./Opis.vue?vue&type=custom&index=0&blockType=router-link&class=hover%3Atext-orange-500%20transition%20duration-300"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__